import { render } from "./TagInput.vue?vue&type=template&id=724c4204"
import script from "./TagInput.vue?vue&type=script&lang=js"
export * from "./TagInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__